import { Box, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import LocationFilter from '../../../../../components/filters/LocationFilter';

import ProgramDeliverableTypesFilter from '../../../../../components/filters/ProgramDeliverableTypes';
import ProjectFilter from '../../../../../components/filters/ProjectFilter';
import WorkflowTypesFilter from '../../../../../components/filters/WorkflowTypes';
import { useDeliverableModalContext } from '../DeliverableModalContext';

const FormInputs = () => {
  const { deliverable, setDeliverable } = useDeliverableModalContext();
  const handleChange = (key: string, value?: string) =>
    setDeliverable((prev) => ({
      ...prev,
      [key]: value,
    }));
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: '8px 0px',
        overflow: 'auto',
        height: '100%',
      }}
    >
      <TextField
        size="small"
        required
        autoFocus
        label="Name"
        variant="outlined"
        value={deliverable?.deliverableTitle ?? ''}
        onChange={(e) => {
          handleChange('deliverableTitle', e.target.value);
        }}
      />
      <Box>
        <ProjectFilter
          projectId={deliverable?.projectId}
          handleChange={(id) => {
            handleChange('projectId', id ?? '');
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        <DatePicker
          sx={{ flex: 1 }}
          label="Due Date"
          slotProps={{
            field: {
              clearable: true,
              onClear: () => handleChange('dueDate', undefined),
            },
            textField: {
              size: 'small',
            },
          }}
          value={deliverable?.dueDate ? dayjs(deliverable?.dueDate) : null}
          onChange={(newDate) => {
            handleChange(
              'dueDate',
              newDate ? dayjs(newDate).toString() : undefined,
            );
          }}
        />

        <LocationFilter
          locationId={deliverable?.locationId}
          handleChange={(id) => {
            handleChange('locationId', id ?? '');
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        <WorkflowTypesFilter
          required
          workflowType={deliverable?.workflowType}
          handleChange={(type) => {
            handleChange('workflowType', type ?? '');
          }}
        />
        <ProgramDeliverableTypesFilter
          required
          programDeliverableTypeId={deliverable?.deliverableTypeId}
          handleChange={(id) => {
            handleChange('deliverableTypeId', id ?? '');
          }}
        />
      </Box>
      <TextField
        size="small"
        label="Description"
        variant="outlined"
        multiline
        minRows={3}
        value={deliverable?.description ?? ''}
        onChange={(e) => {
          handleChange('description', e.target.value);
        }}
      />
    </Box>
  );
};

export default FormInputs;
